module.exports = __webpack_public_path__ + "img/icon-sale.81a70a36.png";